import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    slogen: {
        id: "slogen",
    },
});

export default messages;